import Vue      from 'vue'
import Vuex     from 'vuex'
import axios    from 'axios'

import { runInNewContext } from 'vm';

Vue.use(Vuex)


export default new Vuex.Store({
    state: {
        accessToken: null
    },
    getters: {
    },
    mutations: {
        LOGIN (state, {accessToken}) {
            state.accessToken = accessToken
        },
        LOGOUT (state) {
            state.accessToken = null
        }
    },
    actions: {
        LOGIN ({commit}, {email, password}) {
            let _this = this,
                token = fcmToken;

            axios({
                method: 'post',
                url: resourceHost,
                params: {
                    email:      email,
                    password:   password,
                    fcmtoken:   token
                },
                headers: { 
                    'Content-Type': 'application/json',
                }
            })
            .then(function (response) {
                let user = response.data.user;
                if(user) {
                    localStorage.setItem('Authorization',user.remember_token);
                    localStorage.setItem('user_id',user.id);

                    axios.defaults.headers.common['Authorization'] = `Bearer ${user.remember_token}`;
                    axios.defaults.headers.common['user_id'] = `Bearer ${user.id}`;
                    location.reload('/');
                }else{
                    alert('Invalid login information. please try again');
                }
            })
            .catch(error => {
                alert(error)
            });
        },
        LOGOUT ({commit}) {
            commit('LOGOUT')
        },
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js